import React from "react"
import PropTypes from "prop-types"

import { dinero, piezas } from "../helpers"

const ConfirmBar = ({
  selCount,
  selPiezas,
  selImporte,
  ahorro,
  hayExcesos,
  puedeSolicitar,
  isSaving,
  onLimpiar,
  onSolicitar,
}) => {
  let etiqueta = "Solicitar pedidos"
  if (isSaving) etiqueta = "Guardando…"
  else if (selCount === 1) etiqueta = "Solicitar 1 renglón"
  else if (selCount > 1) etiqueta = `Solicitar ${selCount} renglones`

  return (
    <div className="pv2-bar">
      <div className="pv2-bar-stats">
        <div className="pv2-bar-stat">
          <span className="pv2-bar-label">Renglones</span>
          <span className="pv2-mono pv2-bar-num">{selCount}</span>
        </div>
        <div className="pv2-bar-stat">
          <span className="pv2-bar-label">Piezas</span>
          <span className="pv2-mono pv2-bar-num">{piezas(selPiezas)}</span>
        </div>
        <div className="pv2-bar-stat">
          <span className="pv2-bar-label">Importe</span>
          <span className="pv2-mono pv2-bar-num is-accent">
            ${dinero(selImporte)}
          </span>
        </div>
        <div className="pv2-bar-stat">
          <span className="pv2-bar-label">Ahorro</span>
          <span className="pv2-mono pv2-bar-num is-green">${dinero(ahorro)}</span>
        </div>
        {hayExcesos && (
          <span className="pv2-bar-warn">
            Hay cantidades mayores a lo disponible.
          </span>
        )}
      </div>
      <div className="pv2-bar-actions">
        <button
          type="button"
          className="pv2-btn-ghost"
          onClick={onLimpiar}
          disabled={selCount === 0 || isSaving}
        >
          Limpiar
        </button>
        <button
          type="button"
          className={`pv2-btn-primary${puedeSolicitar ? " is-on" : ""}`}
          onClick={onSolicitar}
          disabled={!puedeSolicitar}
        >
          {etiqueta}
        </button>
      </div>
    </div>
  )
}

ConfirmBar.propTypes = {
  selCount: PropTypes.number.isRequired,
  selPiezas: PropTypes.number.isRequired,
  selImporte: PropTypes.number.isRequired,
  ahorro: PropTypes.number.isRequired,
  hayExcesos: PropTypes.bool,
  puedeSolicitar: PropTypes.bool,
  isSaving: PropTypes.bool,
  onLimpiar: PropTypes.func.isRequired,
  onSolicitar: PropTypes.func.isRequired,
}

export default ConfirmBar
